import { useForm } from "react-hook-form";
import { User } from "../models/user";
import { LoginCredentials }  from "../network/user_api";
import * as UserApi from "../network/user_api";
import { Alert, Button, Form, Modal } from "react-bootstrap";
import TextInputField from "./form/TextInputField";
import { useState } from 'react';
import { UnauthorizedError } from "../errors/http_errors";

interface LoginModalProps {
    onLoginSuccessful: (user: User) => void,
}

const LoggedOutView = ({ onLoginSuccessful }: LoginModalProps) => {

    const [errorText, setErrorText] = useState<string | null>(null);

    const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm<LoginCredentials>();

    async function onSubmit(credentials: LoginCredentials) {
        try {
            const user = await UserApi.login(credentials);
            onLoginSuccessful(user);
        } catch (error) {
            if (error instanceof UnauthorizedError) {
                setErrorText(error.message);
            } else {
                alert(error);
            }
            console.error(error);
        }
    }

    return (
        <Modal show centered>
            <Modal.Header>
                <Modal.Title>
                    Είσοδος
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {errorText &&
                    <Alert variant="danger">
                        {errorText}
                    </Alert>
                }
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <TextInputField
                        name="username"
                        label="e-mail"
                        autoComplete="on"
                        type="text"
                        placeholder=""
                        register={register}
                        registerOptions={{ required: "Απαιτείται όνομα χρήστη" }}
                        error={errors.username}
                    />
                    <TextInputField
                        name="password"
                        label="Κωδικός"
                        type="password"
                        autoComplete="on"
                        placeholder=""
                        register={register}
                        registerOptions={{ required: "Απαιτείται κωδικός" }}
                        error={errors.password}
                    />
                    <Button
                        type="submit"
                        disabled={isSubmitting}
                        className="w-100 btn-dark">
                        Είσοδος
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

export default LoggedOutView;